"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageInferenceErrorCodeSchema = void 0;
const z = require("zod");
const property_key_1 = require("../Consensus/property-key");
const package_data_spec_clause_1 = require("./package-data-spec-clause");
const package_data_spec_status_1 = require("./package-data-spec-status");
exports.PackageInferenceErrorCodeSchema = z.object({
    id: z.string(),
    propertyKey: property_key_1.PropertyKeySchema,
    code: z.string(),
    description: z.string(),
    status: package_data_spec_status_1.PackageDataSpecStatusSchema,
    retirementComment: z.string().nullable(),
    createdByUserId: z.string().nullable(),
    createdBy: package_data_spec_clause_1.SpecAuthorSchema.nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
    retiredByUserId: z.string().nullable(),
    retiredBy: package_data_spec_clause_1.SpecAuthorSchema.nullable(),
    retiredAt: z.date().nullable(),
});
//# sourceMappingURL=package-inference-error-code.js.map